module.exports = __webpack_public_path__ + "img/demigods_600.67dc3c96.png";